import { httpV1 as http } from '../api';

const dashboardPath = '/dashboard/dashboard-admin';
const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function getProductionPerDay(params) {
  return http
    .get(`${dashboardPath}/production-per-day`, { params })
    .then(({ data }) => data);
}

export async function getProposalStatusByPromoter(params) {
  return http
    .get(`${ALT_API_URL}${dashboardPath}/proposal-status-by-promoter`, { params })
    .then(({ data }) => data);
}

export async function getPromoterBalance(params) {
  return http
    .get(`${dashboardPath}/promoter-balance`, { params })
    .then(({ data }) => data);
}

export async function getSelfieStatistics(params) {
  return http
    .get(`${dashboardPath}/selfie-statistics`, { params })
    .then(({ data }) => data);
}

export async function getDisbursementStatus(params) {
  return http
    .get(`${dashboardPath}/disbursement-status`, { params })
    .then(({ data }) => data);
}

export async function getProposalStatus(params) {
  return http
    .get(`${dashboardPath}/proposal-status-chart`, { params })
    .then(({ data }) => data);
}

export async function getProposalPaymentByScore(params) {
  return http
    .get(`${dashboardPath}/proposal-payment-by-score`, { params })
    .then(({ data }) => data);
}

export async function getWarranty(params) {
  return http
    .get(`${dashboardPath}/warranty-chart`, { params })
    .then(({ data }) => data);
}

export async function getUserStatus(params) {
  return http
    .get(`${dashboardPath}/user-status`, { params })
    .then(({ data }) => data);
}

export async function getProductionSummary(params) {
  return http
    .get(`${dashboardPath}/production-summary`, { params })
    .then(({ data }) => data);
}

export async function getCorbanProduction(params) {
  return http
    .get(`${dashboardPath}/promoter-monthly-production`, { params })
    .then(({ data }) => data);
}

export async function fetchPromoterProductionCashbackCommission(dateRange, promoters) {
  const params = {
    ...dateRange,
    promoters,
  };

  return http
    .get(`${dashboardPath}/promoter-production-cashback-commission`, { params })
    .then(({ data }) => data);
}

export async function getExternalDashboardUrls() {
  return http
    .get('/dashboard/external')
    .then(({ data }) => data);
}

export async function getBusinessGoals() {
  return http
    .get('/dashboard/business-goals')
    .then(({ data }) => data);
}
